import axios from 'axios';
import { getToken, clearToken } from './tokenStore';

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  'https://backend-clinical-intake.dizzaroo.com'
).replace(/\/$/, '');

// Create an axios instance with default config
const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  // Send spoke session cookie so Hub tokens in session can be used when present
  withCredentials: true,
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Hub session dead or app JWT invalid — clear local SSO state and re-auth via Hub
    if (error.response && error.response.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = `${API_BASE}/api/auth/login`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
